import { RequestContext } from "@multiweb/types/multiweb";
import { IItemRights, ItemRights, RightType } from "Global/Base/Rights/RightTypes";
import { EOWException } from "OW.Remoting/Basic/OWExceptions";
import { ConditionStore } from "OW.Remoting/Remoting/ConditionStore";
import { IEvaluatedConditionResult } from "OW.Remoting/Remoting/Rights";
import { OWManager } from "../../../../OW.Remoting/Remoting/OWManager";
import { CancellationToken } from "../../Promises/CancellationTokenSource";
import { BaseRightsEvaluator } from "./BaseRightsEvaluator";

/** Vyhodnocuje práva pro editaci jednoho objektu */
export class SingleObjectRightsEvaluator extends BaseRightsEvaluator {
    protected override _getRightValue(itemRight: IItemRights, evaluatedConditions: IEvaluatedConditionResult[], _rightType: RightType): IItemRights {
        if (!itemRight.conditionID) {
            return itemRight; // pokud není podmínka, tak bere hodnota tvrdého práva
        }

        let result: IItemRights = null;
        if (evaluatedConditions && evaluatedConditions.length > 0) {
            const evaluatedCondition = evaluatedConditions.find(c => c.ID === itemRight.conditionID);
            if (evaluatedCondition != null) {
                result = new ItemRights(itemRight.roleID, itemRight.level, evaluatedCondition.Result, itemRight.conditionID, itemRight.isNegative);
            }
        }

        if (result === null)
            throw new EOWException(`Unable to find result of evaluated condition ${itemRight.conditionID} for role ${itemRight.roleID} on level ${itemRight.level}`);

        return result;
    }

    public override async evaluateCondition(conditionID: string, isStatic: boolean, _rightType: RightType, requestContext?: RequestContext): Promise<IEvaluatedConditionResult> {
        let evaluateConditionFunc: (condId: string, requestContext?: RequestContext | CancellationToken) => Promise<boolean>;

        if (isStatic) {
            evaluateConditionFunc = OWManager.evaluateConditionWithoutObject.bind(OWManager); // Pokud se jedná o statickou podmínku (podmínka na statickém prvku), vyhodnocuje se na serveru nezávisle na objektu
        } else {
            if (this._context) {
                evaluateConditionFunc = this._context.evaluateCondition.bind(this._context); // Pokud je k dispozici objekt, vyhodnocuje se na serveru v závislosti na něm
            } else if (!ConditionStore.isLocalEvaluable(conditionID)) {
                //Pokud na framu není vybrán objekt, některé akce (např. ParametricFormAction) mohou mít statickou podmínku (nevztahuje se k objektu), kterou potřebují vyhodnotit na serveru.
                evaluateConditionFunc = OWManager.evaluateConditionWithoutObject.bind(OWManager);
            } else {
                evaluateConditionFunc = () => {
                    return Promise.resolve(null);
                }; // Výsledek vyhodnocení podmínky nestatické metody bez aktuálního objektu bude null / neurčitý / nevyužitý
            }
        }

        const conditionEvaluationResult = await evaluateConditionFunc(conditionID, requestContext);

        return { ID: conditionID, Result: conditionEvaluationResult };
    }
}
